
if (!customElements.get('GlobalPopup')) {
    class GlobalPopup extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.popopEl= this.querySelector(".main-popup-section-content")
        this.CloseBtnEl= this.querySelector(".main-popup-section-content")
        this.confirmBtnEl= this.querySelector(".main-popup-section-content")
        const exitCountry = this.popopEl.getAttribute("data-exit-country").split(",");
        if(exitCountry.indexOf(Shopify.country) <0 ){
            this.popopEl.style.display = "flex";
        }
        this.CloseBtnEl.addEventListener("click",()=>{
            this.popopEl.style.display = "none";
        })
        this.confirmBtnEl.addEventListener("click",()=>{
            this.popopEl.style.display = "none";
        })
      }
     
    }
    customElements.define('global-popup', GlobalPopup);
}